import { useTheme, IconButton } from "@mui/material";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import CloseIcon from "@mui/icons-material/Close";

export interface ExpiryBannerProps {
  message?: string;
}

export default function ExpiryBanner({
  message = "Account access expiring in less than 30 days.",
}: ExpiryBannerProps) {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(true);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          key="expiry-banner"
          exit={{ height: 0, transform: "translateY(-100%)" }}
          style={{
            overflow: "hidden",
            background: theme.palette.error.dark,
            color: "white",
            padding: "0.5em",
            fontSize: "85%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <strong>{message}</strong>&nbsp; Please contact your account manager
          </div>
          <IconButton
            size="small"
            aria-label="Dismiss"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            <CloseIcon
              fontSize="small"
              style={{
                color: "white",
              }}
            />
          </IconButton>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
